import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import { getGroupList } from "../../app/api";


const formatDate = (dateString: any) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const GroupList = () => {
  const [loading, setLoading] = useState(false);
  const {eeljuud, userBio} = useContext(UserContext);
  const [selectedEelj, setSelectedEelj] = useState<any>(undefined);
  const [groupList, setGroupList] = useState([]);
  const [groupListError, setGroupListError] = useState<string | undefined>(undefined);

  const fetchGroupList = useCallback(async (id: string) => {
    setGroupListError(undefined);
    setLoading(true);
    try {
      const resp = await getGroupList({
        eelj_id: id,
      });
      console.log(resp.data);
      if(resp.data) {
        setGroupList(resp.data);
      }
    } catch(err: any) {
      console.log(err);
      setGroupListError(err.response.data.error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if(selectedEelj) {
      fetchGroupList(selectedEelj);
    }
  }, [selectedEelj]);

  return (
    <div className="bg-white py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {loading &&
          <div className="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50">
            <div className="flex justify-center items-center mt-[50vh]">
              <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
                <svg aria-hidden="true" className="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        }
        {userBio?.role === 'teacher' &&
          <>
            <div className="text-2xl mb-8">
              <h1>Ээлжийн хүүхдүүд</h1>
            </div>
            <select className="mb-4" onChange={(e) => {setSelectedEelj(e.target.value);}}>
              <>
                <option value='' disabled selected hidden>
                  Энд дарж ээлжээ сонгоно уу.
                </option>
                {[...eeljuud.activeEelj, ...eeljuud.eelj].map((eelj: any) => {
                  return (
                    <option key={eelj.id} value={eelj.id}>
                      {eelj.title + ' ' + formatDate(eelj.start_date) + ' -> ' + formatDate(eelj.end_date)}
                    </option>
                  )
                })
                }
              </>
            </select>
            {groupList && groupList.length > 0 ?
              <div>
                <table className="table-fixed border-collapse border">
                  <thead>
                    <tr>
                      <th className="border border-size-4 p-2">Овог</th>
                      <th className="border border-size-4 p-2">Нэр</th>
                      <th className="border border-size-4 p-2">РД</th>
                      <th className="border border-size-4 p-2">Утасны дугаар</th>
                      <th className="border border-size-4 p-2">Эцэг эхийн утасны дугаар</th>
                      <th className="border border-size-4 p-2">Линк</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupList.map((v: any) => {
                      return (
                        <tr>
                          <td className="border p-2">{v.user.lastName}</td>
                          <td className="border p-2">{v.user.firstName}</td>
                          <td className="border p-2">{v.user.registerNumber}</td>
                          <td className="border p-2">{v.user.phone}</td>
                          <td className="border p-2">{v.user.parentPhone}</td>
                          <td className="border p-2">
                            <a href={`https://nairamdal.mn/profile/${v.user._id}`} className="text-blue-500 underline">Дэлгэрэнгүй</a>
                          </td>

                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              :
              <div className="p-4">
                Таны бүлэгт хүүхэд олдсонгүй.
              </div>
            }
            {groupListError &&
              <div className="text-red-500 p-4 bg-red-100">
                {groupListError}
              </div>
            }
          </>
        }
      </div>
    </div>
  )
}

export default GroupList;